'use client';

import React from 'react';
import Link from 'next/link';
import type { CategoryWithSubCategories } from '@dr-pam/common-components/Services/Server/CategoryService';

const SLUG_IMAGE_MAP = [
	{ slug: 'help-im-in-a-sleep-emergency', image: '/images/quiz/quiz-emergency.svg' },
	{ slug: 'daytime-sleep-problem', image: '/images/quiz/quiz2.svg' },
	{ slug: 'evening-sleep-problem', image: '/images/quiz/quiz4.svg' },
	{ slug: 'only-sleeps-held-or-carried', image: '/images/quiz/quiz6.svg' },
	{ slug: 'excessive-night-waking', image: '/images/quiz/quiz1.svg' },
	{ slug: 'waking-too-early', image: '/images/quiz/quiz3.svg' },
	{ slug: 'how-can-i-sleep-my-baby-safely', image: '/images/quiz/quiz5.svg' },
	{ slug: 'how-can-i-take-care-of-myself-how-can-others-help-me', image: '/images/quiz/quiz7.svg' },

	// Toddler images
	{ slug: 'help-i-am-in-a-sleep-emergency', image: '/images/quiz/quiz-emergency.svg' },
	{ slug: 'daytime-sleep', image: '/images/quiz/quiz2.svg' },
	{ slug: 'evening-sleep', image: '/images/quiz/quiz4.svg' },
	{ slug: 'night-waking', image: '/images/quiz/quiz1.svg' },
	{ slug: 'waking-early', image: '/images/quiz/quiz3.svg' },
	{ slug: 'only-sleeps-when-held-or-carried', image: '/images/quiz/quiz6.svg' },
];

const EMERGENCY_SLUGS = new Set(['help-im-in-a-sleep-emergency', 'help-i-am-in-a-sleep-emergency']);

type QuizStepChallengeProps = {
	challenges: CategoryWithSubCategories[];
	ageSlug: string;
};

export default function QuizStepChallenge({ challenges, ageSlug }: QuizStepChallengeProps) {
	return (
		<div className="quiz-challenge-container">
			{challenges.map((c, index) => {
				const { name, slug } = c;
				const emergency = EMERGENCY_SLUGS.has(slug);
				const className = emergency ? 'danger icon' : 'Button outline quiz reverse icon';
				const image = SLUG_IMAGE_MAP.find((s) => slug === s.slug)?.image;

				return (
					<Link
						key={index}
						href={`/find-essentials/${ageSlug}/${slug}`}
						className={`Button solid reverse outline item quiz ${className}`}
					>
						{image && (
							// eslint-disable-next-line @next/next/no-img-element
							<img src={image} width={26} height={26} alt="icon" />
						)}
						{name}
					</Link>
				);
			})}
		</div>
	);
}
